import axios from 'axios'
import moment from 'moment'
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'
import {
  Toast
} from 'vant';

// 允许同时存在多个 Toast
Toast.allowMultiple();
//import localStorage from '@utils/localstorage'
moment.locale('zh-cn')
// 统一配置
let SERVICE = axios.create({
  baseURL: process.env.VUE_APP_PANKU_SERVICE,
  timeout: 180 * 1000, // 请求超时时间
  responseType: 'json',
  validateStatus(status) {
    // 200 外的状态码都认定为失败
    return status === 200
  }
})
// 拦截请求
SERVICE.interceptors.request.use((config) => {
  //有 token就带上
  const token = sessionStorage.getItem('USER_TOKEN')
  if (token) {
    config.headers[ACCESS_TOKEN] = token
  }
  // 打开全局请求loading
  if (config && config.customs && config.customs.isLoading) {
    Toast.loading({
      duration: 0,
      forbidClick: true,
      overlay:true,
      message: config.customs.loadingText || '数据加载中...',
    });
  }else{
    Toast.loading({
      duration: 0,
      forbidClick: true,
      // overlay:true,
      message: '数据加载中...',
    });
  }
  return config
}, (error) => {
  Toast.clear(true);
  return Promise.reject(error)
})

// 拦截响应
SERVICE.interceptors.response.use((response) => {
  // 关闭打开全局请求loading
  Toast.clear(true);
  if (response.data.success === false) {
    Toast.fail({
      message: response.data.message,
      overlay:true,
      duration: 8000,
    });
  }
  // 接口请求成功提示
  if (response.data.success && response.config && response.config.customs &&  response.config.customs.successTip) {
    Toast.success({ message: response.config.customs.successTip,overlay:true });
  }
  return response.data;
}, (error) => {
  Toast.clear(true);
  if(error.response && error.response.data && error.response.data.message){
    Toast.fail({
      message: error.response.data.message,
      duration: 8000,
      overlay:true,
    });
  }else{
      Toast.fail({
        message: error.message,
        duration: 8000,
        overlay:true,
      });
  }
  return Promise.reject(error)
})

export default SERVICE
